import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import SideNavButtons from '../components/Common/SideNavButtons';
import { vehicles } from '../data/vehicles.ts';
import CategoryHeading from '../components/Common/CategoryHeading.js';
import ViewToggle from '../components/VehiclesCatalog/view_toggle_component.js';
import VehicleCard from '../components/VehiclesCatalog/vehicle_card_component.js';
import VehicleRow from '../components/VehiclesCatalog/vehicle_row_component.js';
import VehicleModal from '../components/VehiclesCatalog/vehicle_modal_component.js';
import VehicleScreensaver from '../components/VehiclesCatalog/VehicleScreensaver.js';
import ScreensaverButton from '../components/ItemsCatalog/screensaver_button.js';
import '../styles/VehiclesCatalog.css';

const VehiclesCatalog = () => {
  const [selectedVehicle, setSelectedVehicle] = useState(null);
  const [viewMode, setViewMode] = useState(() => {
    const storedViewMode = localStorage.getItem('vehiclesViewMode');
    const isMobile = window.innerWidth <= 768;
    return storedViewMode && !isMobile ? storedViewMode : isMobile ? 'row' : 'card';
  });
  const [isMobile, setIsMobile] = useState(false);
  const [screensaverMode, setScreensaverMode] = useState(false);
  const navigate = useNavigate();

  const handlePrev = () => {
    navigate('/dogtags');
  };

  const handleNext = () => {
    navigate('/packages');
  };

  // Check for itemid in URL params on mount
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const itemId = params.get('itemid');
    if (itemId) {
      const matchedVehicle = vehicles.find(v => v.id === itemId);
      if (matchedVehicle) {
        setSelectedVehicle(matchedVehicle);
      }
    }
  }, []);

  useEffect(() => {
    const checkIfMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    checkIfMobile();
    window.addEventListener('resize', checkIfMobile);
    return () => window.removeEventListener('resize', checkIfMobile);
  }, []);

  // Force row view on mobile
  useEffect(() => {
    if (isMobile) {
      setViewMode('row');
    }
  }, [isMobile]);

  const handleCardClick = (vehicle) => {
    setSelectedVehicle(vehicle);
  };

  const handleModalClose = () => {
    setSelectedVehicle(null);
  };

  const handleModalNavigate = (vehicle) => {
    setSelectedVehicle(vehicle);
  };

  const handleScreensaverToggle = useCallback((e) => {
    e.stopPropagation();
    console.log('Screensaver button clicked - toggling from', screensaverMode, 'to', !screensaverMode);
    setScreensaverMode(prev => {
      const newValue = !prev;
      console.log('New screensaver mode:', newValue);
      return newValue;
    });
  }, [screensaverMode]);

  const handleExitScreensaver = useCallback(() => {
    setScreensaverMode(false);
  }, []);

  if (screensaverMode) {
    return <VehicleScreensaver onExit={handleExitScreensaver} />;
  }

  return (
    <div className="vehicles-catalog">
      <CategoryHeading
        title="OUR VEHICLE FLEET"
        description="Drive A Tank offers the largest fleet of military vehicles and tanks for civilians to drive anywhere in the United States. Check out a portion of our fleet below."
      />

      <SideNavButtons
        onPrev={handlePrev}
        onNext={handleNext}
        prevPageName="DOG TAGS"
        nextPageName="PACKAGES"
      />
      
      {!isMobile && (
        <ViewToggle viewMode={viewMode} setViewMode={setViewMode} />
      )}
      
      <div className={`vehicles-container ${viewMode}`}>
        {vehicles.map((vehicle) =>
          viewMode === "card" ? (
            <VehicleCard
              key={vehicle.id}
              vehicle={vehicle}
              onCardClick={handleCardClick}
            />
          ) : (
            <VehicleRow
              key={vehicle.id}
              vehicle={vehicle}
            />
          )
        )}
      </div>

      {viewMode === "card" && (
        <VehicleModal
          selectedVehicle={selectedVehicle}
          vehicles={vehicles}
          onClose={handleModalClose}
          onNavigate={handleModalNavigate}
        />
      )}
      
      <div className="screensaver-btn-container" onClick={(e) => e.stopPropagation()}>
        <ScreensaverButton
          isActive={screensaverMode}
          onClick={handleScreensaverToggle}
        />
      </div>
    </div>
  );
};

export default VehiclesCatalog;
